import { render, staticRenderFns } from "./ContactsLinks.vue?vue&type=template&id=43dc28dc"
import script from "./ContactsLinks.vue?vue&type=script&lang=js"
export * from "./ContactsLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports